import React from "react";
import "./spinner.css";

const Spinner = () => {
  return (
    <div
      css={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        height: "100%"
      }}
    >
      <div className="loadingio-spinner-bean-eater-34ph8wxdizj">
        <div className="ldio-73rna5jl916">
          <div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
